import { StyleSheet } from 'react-native'

export default (multiplier, style) => {
  const convertedStyles = {}
  Object.keys(style).forEach((styleName) => {
    const styleObj = style[styleName]
    const styleOverride = {}
    const svgStyle = styleName.startsWith('svg')
    Object.keys(styleObj).forEach((key) => {
      if (key === 'fontSize') {
        styleOverride.fontSize = styleObj.fontSize * multiplier
      } else if (key === 'lineHeight') {
        styleOverride.lineHeight = styleObj.lineHeight * multiplier
      } else if (svgStyle && (key === 'width' || key === 'height' || key === 'borderRadius')) {
        styleOverride[key] = styleObj[key] * multiplier
      } else {
        styleOverride[key] = styleObj[key]
      }
    })
    convertedStyles[styleName] = styleOverride
  })
  return StyleSheet.create(convertedStyles)
}
